import { render, staticRenderFns } from "./GroupMemberContentCellRenderer.vue?vue&type=template&id=63168560&"
import script from "./GroupMemberContentCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberContentCellRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports